import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Business from "./Business";
import Testimonial from "./Testimonial";

export default function Banking() {
    // const bannerRef = useRef(null);
    // const navRef = useRef(null);
    // const overviewRef = useRef(null);
    // const sectorRef = useRef(null);
    // const benefitsRef = useRef(null);
    // const customerRef = useRef(null);
    // const contactRef = useRef(null);

    // const [isFixed, setIsFixed] = useState(false);
    

    // useEffect(() => {
    //     const handleScroll = () => {
    //         if (bannerRef.current && navRef.current) {
    //             const bannerBottom = bannerRef.current.getBoundingClientRect().bottom;
    //             setIsFixed(bannerBottom <= 0)
    //         }
    //     };
    //     window.addEventListener('scroll', handleScroll);
    //     return () => window.removeEventListener('scroll', handleScroll)
    // }, [])

    // const scrollToSection = (ref) => {
    //     ref.current.scrollIntoView({ behavior: "smooth", block: "start" })
    // }

 
    return (
        <>
            <div className="aboutus_bg" >
                <div className="aboutus-img-content">
                    <h1>Banking</h1>
                </div>
            </div>

            {/* *Tab navigatior */}
            {/* <div
                ref={navRef}
                className={`tab-navigation ${isFixed ? "fixed-top" : ""}`}
                style={{
                    backgroundColor: '#ffffffb3',
                    padding: '10px 0',
                    zIndex: 1000,
                }}
            >
                <Container>
                    <Row>
                        <Col>
                            <ul className="nav nav-tabs justify-content-center">
                                <li className="nav-item">
                                    <button className="nav-link" onClick={() => scrollToSection(overviewRef)}>
                                        Overview
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button className="nav-link" onClick={() => scrollToSection(sectorRef)}>
                                        Sector
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button className="nav-link" onClick={() => scrollToSection(benefitsRef)}>
                                        Benefits
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button className="nav-link" onClick={() => customerRef.current?.scrollIntoView({behavior:'smooth',block:"start"})}>
                                        Customer stories
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button className="nav-link" onClick={() => contactRef.current?.scrollIntoView({behaviour:'smooth',block:"start"})}>
                                        Contact us
                                    </button>
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </div> */}
            <Container className="it-overview mt-5 mb-5" >
                {/* <h6>OVERVIEW</h6> */}
                <h3 className="text-center" style={{ color: '#0e2b5c', paddingBottom: '15px' }}>Revolutionizing Financial Services with Digital Innovation</h3>
                <div className="overview-container" style={{ padding: '0 12%', color: '#627792', fontSize: '18px', fontWeight: '500', lineHeight: '1.8' }}>
                    <p >The banking sector thrives on trust and efficiency. Our tech-driven solutions streamline banking operations, enhance customer experiences, and strengthen security in an ever-evolving financial landscape. By leveraging AI and blockchain, we enable frictionless transactions, fraud prevention, and superior financial management. We help banks modernize legacy systems, ensuring a seamless and compliant digital transformation.
                    </p>
                </div>
            </Container>

            {/**sector */}

            {/* <div className="sector-container" ref={sectorRef}>
                <Container className="pt-5">
                    <h6 className="text-uppercase text-center mb-2">Sectors</h6>
                    <h2 className="text-center mb-5" style={{ color: ' #0e2b5c', fontSize: '500' }}>Key Benefits in managing your hiring needs</h2>
                    <Row className="g-4 row-cols-1 row-cols-lg-5">
                        {benefits.map((benefit, index) => (
                            <Col md={4} key={index} className="text-center mb-5">
                                <Row>
                                    <Col md={4}>
                                        <i className={`${benefit.iconClass} fa-2x mb-3`} style={{ color: '#0e2b5c' }}></i>
                                    </Col>
                                    <Col md={8}>
                                        <h5 style={{ textAlign: 'left', color: '#0e2b5c' }}>{benefit.title}</h5>
                                        <h6 style={{ color: '#9b9aad', textAlign: 'left', lineHeight: '1.6' }}>{benefit.description}</h6>
                                    </Col>
                                </Row>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div> */}

            {/**benefit */}

            <section className="py-5 text-light mb-5" style={{ backgroundColor: "#141b29" }} >
                {/* <h6 className="text-uppercase text-center text-info mb-2">Benefits to bank on</h6> */}
                <h2 className="text-center mb-5">Our Solutions for Banking
                </h2>
                <Container>
                    <Row>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>AI-powered fraud detection strengthens security and enhances real-time security.</h5>
                                <p>Leverage machine learning algorithms to detect unusual transaction patterns, flag potential threats, and prevent fraudulent activities in real time. Our advanced fraud detection systems continuously analyze vast amounts of financial data, minimizing risks and enhancing customer trust. With predictive analytics, businesses can proactively combat cyber threats and unauthorized access.</p>
                            </div>
                        </Col>
                        <Col  sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>Omnichannel banking experience to improve customer engagement</h5>
                                <p>Deliver a seamless and personalized banking experience across mobile apps, web platforms, ATMs, and in-branch services. Customers can manage their finances effortlessly through integrated digital and physical banking channels, improving satisfaction and loyalty. Our solutions ensure secure, frictionless interactions, enabling banks to offer convenience and flexibility at every touchpoint.</p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>Compliance solutions to navigate financial laws effortlessly</h5>
                                <p>Stay ahead of evolving financial regulations with AI-driven compliance monitoring and automated reporting tools. Our solutions help institutions reduce compliance costs, prevent penalties, and ensure adherence to industry standards. By integrating real-time risk assessment and regulatory updates, businesses can streamline audits and maintain a secure financial ecosystem.
                                </p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>AI-driven risk assessment for smarter decision-making</h5>
                                <p>Utilize AI-powered models to evaluate creditworthiness, detect financial risks, and optimize investment strategies. Our intelligent risk assessment tools analyze historical data, market trends, and customer behaviors to provide accurate risk predictions. With automated risk scoring and portfolio management, financial institutions can make data-driven decisions with confidence.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>

            </section>

            {/**delivery */}
            {/* <section className="delivery-container">
                <h6 className="text-uppercase text-center mb-2">Delivery</h6>
                <h2 className="delivery-title">

                    Transform your technology by focusing on 3 key areas
                </h2>

                <div className="delivery-content">

                  
                    <div className="delivery-box">
                        <div className="delivery-icon">
                            <img src="/images/datat.svg" alt="Data transformation" />
                        </div>
                        <div className="title-with-number">
                            <Row className="row-number">
                                <Col md={2}>
                                    <div className="number-circle">1</div>
                                </Col>
                                <Col md={10} className="text-left">
                                    <h3>Data transformation</h3>
                                    <p>
                                        Accelerate “Data-to-Insight-to-Action” cycle, by consuming offerings
                                        like Data-as-a-Service and Reporting-as-a-Service.
                                    </p>
                                </Col>
                            </Row>


                        </div>


                    </div>

                
                    <div className="arrow"><i className="fa-solid fa-chevron-right"></i></div>

                   
                    <div className="delivery-box">
                        <div className="delivery-icon">
                            <img src="/images/ena.svg" alt="Digital enablement" />
                        </div>
                        <div className="title-with-number">
                            <Row className="row-number">
                                <Col md={2}>
                                    <div className="number-circle">2</div>
                                </Col>
                                <Col md={10} className="text-left">
                                    <h3>Data transformation</h3>
                                    <p>
                                        Accelerate “Data-to-Insight-to-Action” cycle, by consuming offerings
                                        like Data-as-a-Service and Reporting-as-a-Service.
                                    </p>
                                </Col>
                            </Row>


                        </div>
                    </div>

                   
                    <div className="arrow"><i className="fa-solid fa-chevron-right"></i></div>

                 
                    <div className="delivery-box">
                        <div className="delivery-icon">
                            <img src="/images/hand.svg" alt="Innovation partnership" />
                        </div>
                        <div className="title-with-number">
                            <Row className="row-number">
                                <Col md={2}>
                                    <div className="number-circle">3</div>
                                </Col>
                                <Col md={10} className="text-left">
                                    <h3>Data transformation</h3>
                                    <p>
                                        Accelerate “Data-to-Insight-to-Action” cycle, by consuming offerings
                                        like Data-as-a-Service and Reporting-as-a-Service.
                                    </p>
                                </Col>
                            </Row>


                        </div>
                    </div>
                </div>
            </section> */}

            {/**expertise */}

            {/* <section className="py-5" style={{ backgroundColor: "#f3f6f9" }}>
                <Container>
                    <Row>
                        <Col sm={12} md={12} lg={6} className="mt-4">
                            <div className="banking-content">
                                <h6 className="text-uppercase mb-2">Expertise</h6>
                                <h2 className="mb-3" style={{ color: '#0e2b5c', fontWeight: 'bold' }}>Our banking expertise</h2>
                                <p style={{ paddingRight: '10px', marginBottom: '5%' }}>NanoSoft is a joint venture between Linethemes and Themeforest. Our experts have deep knowledge about the complexities of the banking industry,
                                    and know how to deploy digital technology to transform banks’ operations.</p>
                                <Row>
                                    <Col md={6}>
                                        <h2 style={{ fontSize: '3rem', fontWeight: 'bold', color: '#0e2b5c' }}>300<span style={{ fontSize: '30px', color: '#9b9aad' }}>+</span></h2>
                                        <p>Financial services firms worldwide</p>
                                    </Col>
                                    <Col md={6}>
                                        <h2 style={{ fontSize: '3rem', fontWeight: 'bold', color: '#0e2b5c' }}>7<span style={{ fontSize: '30px', color: '#9b9aad' }}>/10</span></h2>
                                        <p>Financial services firms worldwide</p>
                                    </Col>

                                </Row>
                            </div>

                        </Col>
                        <Col sm={12} md={12} lg={6}>
                            <div className="image-container">
                                <img src="/images/din.jpg" alt="banking" width={'100%'} />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section > */}
            
            <Business />
        </>
    )
}